export default __webpack_public_path__ + "static/media/fecacera_logo.d438dc04.webp";